import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import { withStyles, withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// ours
import { uuidv4 } from '../../../common';
import Waiting from '../../Waiting';

import Form from './Form'; // eslint-disable-line no-undef
import { STEP_COMPS } from './ConfigureAggregationsV2.const';

const styles = () => ({});

// Form
// + Scopes
// + Topics
//   + Divisions
//   + Inputs

class ConfigureAggregations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: -1,
      stepProps: {}
    };

    this.form = new Form();
  }
  componentDidMount() {
    this.setState(this.form.nextState());
  }
  render() {
    const { step, stepProps, loading } = this.state;
    if (loading) {
      return <Waiting height="300px" />;
    }

    if (step === -1) {
      return null;
    }
    const StepComponent = STEP_COMPS[step];
    const self = this;
    return (
      <StepComponent
        {...stepProps}
        onComplete={
          function (/* arguments */) {
            const uuid = uuidv4();
            self.activeReq = uuid;
            self.timeout = setTimeout(() => {
              if (uuid !== self.activeReq) {
                return;
              }
              self.setState({
                loading: true
              });
            }, 150);
            stepProps.onComplete(...arguments, (s) => {
              if (self.timeout) {
                clearTimeout(self.timeout);
                self.timeout = null;
              }
              self.activeReq = null;
              if (s) {
                self.setState({
                  ...s,
                  loading: false
                });
              } else {
                self.setState(self.form.nextState());
              }
            });
          }
        }
      />
    );
  }
}

ConfigureAggregations.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

ConfigureAggregations.defaultProps = {};

export default withTheme(withStyles(styles)(ConfigureAggregations));
